import { Visibility, VisibilityOff } from '@mui/icons-material'
import { Box, IconButton, InputAdornment, TextField, Typography } from '@mui/material'
import React, { useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useUserContext } from '../../context/userContext'
import SaveIcon from '@mui/icons-material/Save'
import CloseIcon from '@mui/icons-material/Close'
import EditIcon from '@mui/icons-material/Edit'

export const AccountPassword: React.FC = () => {
  const [showNewPassword, setShowNewPassword] = useState(false)
  const [showOldPassword, setShowOldPassword] = useState(false)
  const navigate = useNavigate()
  const { changePassword } = useUserContext()
  const [ableToEdit, setAbleToEdit] = useState(true)
  const newPasswordRef = useRef<HTMLInputElement>()
  const oldPasswordRef = useRef<HTMLInputElement>()

  const toggleOldPassword = () => {
    if (!ableToEdit) {
      showOldPassword ? setShowOldPassword(false) : setShowOldPassword(true)
    }
  }

  const toggleNewPassword = () => {
    if (!ableToEdit) {
      showNewPassword ? setShowNewPassword(false) : setShowNewPassword(true)
    }
  }

  return (
    <Box
      sx={{ display: 'flex', alignItems: 'center', width: '350px', height: '50px', gap: '10px' }}
    >
      {ableToEdit ? (
        <>
          <Typography>*******************</Typography>
          <IconButton
            onClick={() => {
              setAbleToEdit(false)
            }}
          >
            <EditIcon />
          </IconButton>
        </>
      ) : (
        <>
          <TextField
            fullWidth
            disabled={ableToEdit}
            variant='outlined'
            type={showOldPassword ? 'text' : 'password'}
            InputProps={{
              endAdornment: (
                <InputAdornment position='end' onClick={toggleOldPassword}>
                  <IconButton disabled={ableToEdit}>
                    {showOldPassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
            inputRef={oldPasswordRef}
          />
          <TextField
            fullWidth
            disabled={ableToEdit}
            variant='outlined'
            type={showNewPassword ? 'text' : 'password'}
            InputProps={{
              endAdornment: (
                <InputAdornment position='end' onClick={toggleNewPassword}>
                  <IconButton disabled={ableToEdit}>
                    {showNewPassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
            inputRef={newPasswordRef}
          />
          <IconButton
            onClick={async () => {
              setAbleToEdit(true)

              if (
                newPasswordRef.current &&
                newPasswordRef.current.value !== '' &&
                oldPasswordRef.current &&
                oldPasswordRef.current.value !== ''
              ) {
                await changePassword(oldPasswordRef.current.value, newPasswordRef.current.value)
                navigate(0)
              }
            }}
          >
            <SaveIcon />
          </IconButton>
          <IconButton
            onClick={() => {
              setAbleToEdit(true)
              if (newPasswordRef.current) {
                newPasswordRef.current.value = ''
              }
              setShowOldPassword(false)
              setShowNewPassword(false)
            }}
          >
            <CloseIcon />
          </IconButton>
        </>
      )}
    </Box>
  )
}
